import * as t from "io-ts";
import nullable from "./nullable";
export const businessCentralConfigT = t.strict({
    accessTokenStatus: t.union([
        t.literal("UNINITIALIZED"),
        t.literal("INITIALIZED"),
        t.literal("TOKEN_REVOKED"),
        t.literal("INVALID"),
    ]),
    tenantId: nullable(t.string),
    environmentName: nullable(t.string),
    companyId: nullable(t.string),
});
export const businessCentralEnvironmentT = t.strict({
    name: t.string,
    type: t.string,
    url: t.string,
    loginUrl: t.string,
});
export const businessCentralCompanyT = t.strict({
    id: t.string,
    name: t.string,
});
//# sourceMappingURL=business-central-config.js.map